<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    fill="none"
  ><path
    stroke="currentColor"
    stroke-linecap="round"
    stroke-linejoin="round"
    stroke-width="1.75"
    d="m2.266 22.442 5.562-20.86M21.734 22.442l-5.562-20.86M12 16.88v5.562M12 8.535v4.172M12 1.582v2.782"
  /></svg>
</template>
